import React, { useEffect , useState} from "react";
import "./Profile.css";
import { useSelector } from "react-redux";
import { editProfile, fetchProfile } from "../../Api/Login";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Profile = () => {
  const navigate = useNavigate()
  const token = useSelector(state => state.login.token);
const [profile, setProfile] = useState({
  storeName: '',
  name: '',
  phone: '',
  email: '',
  address: '',
  gst: '',
  returnPolicy: '',
  description: '',
  logo: ''
})

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchProfile(token)
        setProfile(response.data)
    } catch (error) {
      console.log(error);
      }   
    }
    fetchData()
  }, [])
  
  const handleChange = (event) => {
    const { name, value } = event.target;
    setProfile(prevProfile => ({
      ...prevProfile,
      [name]: value
    }));
  }
  const handleAddLogo = (event) => {
     if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const newLogoImg = e.target.result;

        setProfile((prev) => ({
          ...prev,
          logo: newLogoImg,
        }));
       
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }
  
  //save profile
  const handleSaveProfile = async () => {
    try {
      const response = await editProfile(token, profile)
      toast.success(response.message)
      navigate('/profile')
    } catch (error) {
      toast.error(error.message)
    }
  }
  return (
    <div className="profile-container">
      <div className="profile-header">
        <h1>Profile</h1>
        <button className="save-button" onClick={handleSaveProfile}>Save</button>
      </div>
      <div className="profile-content">
        <div className="profile-logo-section">
          <div className="profile-logo">
            <img 
              src={profile.logo} 
              alt="Profile Logo" 
            />
          </div>
          <label className="add-logo-button">
            <input 
              type="file" 
              accept="image/*"
              onChange={handleAddLogo}
              style={{ display: 'none' }}
            />
            Add Logo
          </label>
        </div>
        <div className="profile-details">
          <p>Store Name</p>
          <input
            type="text"
            className="profile-input profile-name"
            value={profile.storeName}
            name="storeName"
            onChange={handleChange}
          />
           <p>Owner Name</p>
          <input
            type="text"
            className="profile-input profile-name"
            value={profile.name}
            name="name"
            onChange={handleChange}
          />
          <p>Registered Mobile Number</p>
          <input
            type="text"
            className="profile-input"
            value={profile.phone}
            name="phone"
            onChange={handleChange}
          />
          <p>Email</p>
          <input
            type="email"
            className="profile-input"
            value={profile.email}
            name="email"
            onChange={handleChange}
          />
          <p>Address</p>
          <textarea
            className="profile-input"
            rows="2"
            value={profile.address}
            name="address"
            onChange={handleChange}
          ></textarea>
          <p>GST Number</p>
          <input
            type="text"
            className="profile-input"
            value={profile.gst}
            name="gst"
            onChange={handleChange}
          />
          <p>Return Policy</p>
          <textarea
            className="profile-input"
            rows="4"
            value={profile.returnPolicy}
            name="returnPolicy"
            onChange={handleChange}
          ></textarea>
          <p>Description</p>
          <textarea
            className="profile-input"
            rows="4"
            value={profile.description}
            name="description"
            onChange={handleChange}
          ></textarea>
        </div>
      </div>
    </div>
  );
};

export default Profile;
